import { CircleCheck2Icon, CircleMinusIcon, CircleXIcon } from "@/icons";
import { ValCallResult } from "@/models/pipeline";

type ValCallStatusProps = {
  status: ValCallResult;
};

export const ValCallStatus: React.FC<ValCallStatusProps> = ({ status }) => {
  switch (status) {
    case ValCallResult.Completed:
      return <CircleCheck2Icon />;
    case ValCallResult.NotCompleted:
      return <CircleXIcon />;
    case ValCallResult.NotRequired:
      return <CircleMinusIcon />;
    default:
      return null;
  }
};
